module.exports = __webpack_public_path__ + "static/media/user-graduate.357ac827.svg";